import { FC } from 'react';
import { Segmented } from 'antd';
import { TbDevices, TbMoon, TbPalette, TbSun } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

const ThemeSegmented: FC = (): JSX.Element => {
    const { themeName, setTheme, themeOptions, token } = useAntDesignTheme();
    const iconByType = {
        dark: TbMoon,
        light: TbSun,
        system: TbDevices,
        workspace: TbPalette,
    };

    return (
        <Segmented
            aria-label='Theme'
            value={themeName}
            onChange={(value) => {
                setTheme(String(value));
            }}
            options={themeOptions.map(({ disabled, label, name, type }) => {
                const Icon = iconByType[type];

                return {
                    disabled,
                    value: name,
                    icon: <Icon aria-label={label} role='img' size='1rem' style={{ verticalAlign: '-0.175rem' }} />,
                };
            })}
            style={{ border: `1px solid ${token.colorBorder}` }}
        />
    );
};

export default ThemeSegmented;
